import { MissingProductItem, SofaConfigurationItem, RangeSettings } from 'sofa-reborn-react';

import { ProductUtils } from '../../../util/ProductUtils';
import { UrlService } from '../../../services';

import { IProduct } from '@inter-ikea-kompis/types';
import { ProductData, Product } from '@ikea-aoa/component-view-3d';

export default class ThunksUtil {
	public static hasMissingAutoConnectProduct(
		rangeSettings: RangeSettings,
		products: ProductData,
		missingProducts: MissingProductItem[],
		configurationChildren: SofaConfigurationItem[] | undefined
	): boolean {
		let hasMissingAutoConnectProduct = false;
		if (configurationChildren) {
			const includedInProducts =
				Object.keys(products).find(
					(product) =>
						products[product].productId === (configurationChildren[0].articleId as string)
				) !== undefined;

			const cover = includedInProducts
				? ProductUtils.getColor(products[configurationChildren[0].articleId as string])
				: ProductUtils.getColor(
						missingProducts.find(
							(product) =>
								product.productId === (configurationChildren[0].articleId as string) ||
								product.previousId === (configurationChildren[0].articleId as string)
						) as MissingProductItem
				  );

			hasMissingAutoConnectProduct =
				!Object.values(products).some(
					(prod: Product) =>
						(rangeSettings.addAutomatically
							? rangeSettings.addAutomatically.includes(prod.modelId)
							: prod.filter.family === 'ARMREST') && prod.filter.color === cover
				) &&
				missingProducts.some(
					(prod) =>
						(rangeSettings.addAutomatically
							? rangeSettings.addAutomatically.includes(prod.modelId)
							: prod.filter.family === 'ARMREST') && prod.filter.color === cover
				);
		}

		return hasMissingAutoConnectProduct;
	}

	public static containsMissingProduct(
		products: ProductData,
		missingProducts: MissingProductItem[],
		sofaConfigurationItems: SofaConfigurationItem[] | undefined
	): boolean {
		let hasMissingProduct = false;
		if (sofaConfigurationItems) {
			for (let i = 0; i < sofaConfigurationItems.length; i++) {
				const isPrevious = ProductUtils.isPreviousId(
					products,
					sofaConfigurationItems[i].articleId as string
				);
				const articleId = isPrevious
					? ProductUtils.getNewIdFromPrevious(
							products,
							sofaConfigurationItems[i].articleId as string
					  )
					: sofaConfigurationItems[i].articleId;

				hasMissingProduct =
					missingProducts.some(
						(product) => product.productId === articleId || product.previousId === articleId
					) ||
					this.containsMissingProduct(
						products,
						missingProducts,
						sofaConfigurationItems[i].children as SofaConfigurationItem[]
					);

				if (hasMissingProduct) {
					break;
				}
			}
		}
		return hasMissingProduct;
	}

	public static removeParamFromUrl(param: string): void {
		const locationSearch = UrlService.removeParam(param, UrlService.getSearchString());
		const newHash = UrlService.removeParam(param, location.hash);
		UrlService.setBrowserWindowHash(newHash, locationSearch);
	}

	public static getProductItemId(product: IProduct, useLocalIds: boolean): string {
		if (product.content) {
			return useLocalIds
				? product.content.itemNoLocal || ''
				: product.content.itemNoGlobal || product.content.itemNoLocal || '';
		}
		return product.itemId.slice(4);
	}
}
